class BoutiqueListing extends HTMLElement {
  constructor () {
    super()

    this.slidesEl = this.querySelector('[data-el="boutique-listing.slides"]')
    this.slideEls = this.querySelectorAll('[data-el="boutique-listing.slide"]')

    if (this.slideEls.length < 2) return

    this.carousel = this.initialiseCarousel()
  }

  initialiseCarousel () {
    // eslint-disable-next-line new-cap
    return new window.KeenSlider551(this.slidesEl, {
      slides: '.car-Carousel_Slide',
      slidesPerView: 1.2,
      spacing: 15,
      rubberband: false,
      breakpoints: {
        '(min-width: 600px)': {
          slidesPerView: 2,
          spacing: 15
        },
        '(min-width: 768px)': {
          slidesPerView: 1,
          spacing: 0
        }
      },
      created: () => {
        this.slidesEl.classList.remove('car-Carousel_Slides-hidden')
      }
    })
  }
}

customElements.define('boutique-listing', BoutiqueListing)
